// extracted by mini-css-extract-plugin
export default {"container":"info-description_container__K5NOu","title":"info-description_title__BC+gT","description":"info-description_description__SKVjx"};